import { FC, Props } from "./typings";
import { ClickAwayListener, Popper as PopperMui } from "@mui/material";
import styles from "./styles.module.scss";

const Popper: FC<Props> = ({
  anchorEl,
  placement = "bottom-end",
  open,
  setOpen,
  children,
  virtualElement,
  closeOnClickAway = true,
  autoHide = true,
  overlay = true,
}) => {
  return (
    <>
      {open && overlay && <div className={styles.overlay}></div>}
      <PopperMui
        open={open}
        anchorEl={virtualElement ?? anchorEl}
        placement={placement}
        disablePortal={false}
        modifiers={[
          { name: "hide", enabled: autoHide },
          {
            name: "flip",
            enabled: autoHide,
            options: {
              altBoundary: false,
              rootBoundary: "viewport",
              padding: 8,
            },
          },
          {
            name: "preventOverflow",
            enabled: autoHide,
            options: {
              altAxis: true,
              // altBoundary: true,
              tether: true,
              rootBoundary: "viewport",
              padding: 8,
            },
          },
        ]}
      >
        <ClickAwayListener
          onClickAway={(e) => {
            if (!closeOnClickAway) return;
            if (e.target instanceof HTMLAnchorElement) {
              if (e.target.getAttribute("download")) {
                return;
              }
            }
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            setOpen(false);
          }}
        >
          <div className={styles.popperWrapper}>{open && children}</div>
        </ClickAwayListener>
      </PopperMui>
    </>
  );
};

export default Popper;
